module.exports = __webpack_public_path__ + "static/media/alternative-dark.5cecba81.svg";